import { useEffect, useState } from "react";
import LoadingComponent from "../../widgets/LoadingComponent";
import { getData } from "../../api/ApiRest";
import { FaEye } from "react-icons/fa6";
import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { formatDateddMMyyyyhhmm } from "../../widgets/DateTime";
import AsyncSelect from 'react-select/async';

function BandejaEnviados() {
    const [loading, setLoading] = useState(false);
    const [correoEnviados, setCorreoEnviados] = useState([]);
    const [modalEnviado, setModalEnviado] = useState({ ModalVisible: false, Titulo: '' });
    const [dataBuscar, setDataBuscar] = useState({
        fechaIni: new Date().toISOString().split("T")[0], fechaFin: new Date().toISOString().split("T")[0], correoid: '', Cliente: ''
    });
    const [infoCorreo, setInfoCorreo] = useState({
        correoOrigen: '', correoDestino: '', asunto: '', fecha: '', cuerpo: '', correoCopia: ''
    });

    ///Función para visualizar todos aquellos correos enviados previamente
    const visualizarCorreoEnviados = (item = '') => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getCorreoEnviados', {
            fechaIni: dataBuscar.fechaIni,
            fechaFin: dataBuscar.fechaFin,
            correoid: item,
            cliente: dataBuscar.Cliente || ''
        }).then(response => {
            if (response.status && item === '')
                setCorreoEnviados(response.correoEnviados);
            else {
                let correoEnviado = response.correoEnviados.filter(x => x.correoEnviadoid === item)[0];

                setInfoCorreo({
                    correoOrigen: correoEnviado.correoOrigen,
                    correoDestino: correoEnviado.correoDestino,
                    asunto: correoEnviado.asunto,
                    fecha: correoEnviado.fecha,
                    cuerpo: correoEnviado.cuerpo,
                    correoCopia: correoEnviado.emailCopiado
                })
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Administración</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Bandeja enviados</Breadcrumb.Item>
        </Breadcrumb>

        <div className='row'>
            <div className='col-md-2'>
                <FloatingLabel
                    controlId="Fecha"
                    label="Fecha Inicial"
                    className="mb-3"
                >
                    <Form.Control
                        size='sm'
                        type="date"
                        autoComplete='off'
                        placeholder="Fecha"
                        value={dataBuscar.fechaIni}
                        onChange={value => setDataBuscar({ ...dataBuscar, fechaIni: value.target.value })}
                    />
                </FloatingLabel>
            </div>
            <div className='col-md-2'>
                <FloatingLabel
                    controlId="Fecha"
                    label="Fecha Fin"
                    className="mb-3"
                >
                    <Form.Control
                        size='sm'
                        type="date"
                        autoComplete='off'
                        placeholder="Fecha"
                        value={dataBuscar.fechaFin}
                        onChange={value => setDataBuscar({ ...dataBuscar, fechaFin: value.target.value })}
                    />
                </FloatingLabel>
            </div>
            <div className='col-md-5'>
                <AsyncSelect cacheOptions defaultOptions
                    menuPosition='fixed'
                    noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                    placeholder="Cliente"
                    isClearable={true}
                    loadOptions={companieSearchSelect2}
                    onChange={value => {
                        if (value === null) {
                            setDataBuscar({ ...dataBuscar, Cliente: '' });
                        } else {
                            setDataBuscar({ ...dataBuscar, Cliente: value.value });
                        }
                    }}
                    styles={{
                        control: (base) => ({
                            ...base,
                            minHeight: 58
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                />
            </div>
            <div className="col-md-1">
                <Button variant='primary' type='submit' onClick={() => visualizarCorreoEnviados()}>
                    <FaSearch size={'1rem'} />
                </Button>
            </div>
        </div>

        <div className="row">
            {<LoadingComponent Loading={loading} />}
            <div className='table-responsive'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">
                                Correo origen
                            </th>
                            <th className="estilo-encabezado">
                                Correo destino
                            </th>
                            <th className="estilo-encabezado">
                                Asunto
                            </th>
                            <th className="estilo-encabezado">
                                Fecha
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {correoEnviados.map((item, index) => (
                            <tr key={item.correoEnviadoid}>
                                <td className='text-center'>
                                    <Button type='button' variant='primary' size='sm' title='Visualizar correo'
                                        style={{ fontSize: 12 }}
                                        onClick={() => {
                                            setModalEnviado({ ModalVisible: true, Titulo: 'Correo enviado' });
                                            setDataBuscar({ ...dataBuscar, correoid: item.correoEnviadoid });

                                            visualizarCorreoEnviados(item.correoEnviadoid);
                                        }}>
                                        <FaEye size={'1rem'} />
                                    </Button>
                                </td>
                                <td className="text-center" style={{ fontSize: 13 }}>
                                    {item.correoOrigen}
                                </td>
                                <td className='text-center' style={{ fontSize: 13 }}>
                                    {item.correoDestino}
                                </td>
                                <td className='text-center' style={{ fontSize: 13 }}>
                                    {item.asunto}
                                </td>
                                <td className='text-center' style={{ fontSize: 13 }}>
                                    {formatDateddMMyyyyhhmm(item.fecha)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

        <Modal
            show={modalEnviado.ModalVisible}
            onHide={() => {
                setModalEnviado({ ModalVisible: false, Titulo: '' })
            }}
            backdrop="static"
            keyboard={false}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalEnviado.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId="CorreoOrigen"
                            label="Correo origen"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="text"
                                autoComplete='off'
                                value={infoCorreo.correoOrigen}
                                disabled
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId="CorreoDestino"
                            label="Correo destino"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="text"
                                autoComplete='off'
                                value={infoCorreo.correoDestino}
                                disabled
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-4'>
                        <FloatingLabel
                            controlId="AsuntoCorreo"
                            label="Asunto"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="text"
                                autoComplete='off'
                                value={infoCorreo.asunto}
                                disabled
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-2'>
                        <FloatingLabel
                            controlId="fechaCorreo"
                            label="Fecha"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="datetime"
                                autoComplete='off'
                                value={infoCorreo.fecha}
                                disabled
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <FloatingLabel
                            controlId="copiaCorreo"
                            label="Correo copia"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="text"
                                autoComplete='off'
                                value={infoCorreo.correoCopia}
                                disabled
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <div className="row">
                    <div className='container mt-4'>
                        <div
                            className="border p-3 rounded bg-light"
                            dangerouslySetInnerHTML={{ __html: infoCorreo.cuerpo }}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </div>
}

export default BandejaEnviados;